/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class MasterSaleFormat extends DaoModel {
  constructor(guid, name, title_es, title_en, order, group) {
    super(guid);
    this.name = name || '';
    this.title_es = title_es || '';
    this.title_en = title_en || '';
    this.order = order || 0;
    this.group = group || '';
  }

  get title() {
    return this.translateAttribute('title');
  }

  static toInstance(props = {}) {
    return new MasterSaleFormat(props.guid, props.name, props.title_es, props.title_en,
      props.order, props.group);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      title_es: this.title_es,
      title_en: this.title_en,
      order: this.order,
      group: this.group
    };
  }
}
